import { constructEnum } from '@/lib/enum';

const WidgetExecutionEnvironment = constructEnum('WidgetExecutionEnvironment', {
  SHOP: '100',
  STANDALONE: '300'
});

export default WidgetExecutionEnvironment;
